<template>
  <dialog-form-save-nomenclature-by-provider-and-date
    :visible="visible"
    :status-download="statusDownloadNomenclature"
    :link-download="linkDownloadNomenclature"
    @save="saveNomenclature"
    @closeDialog="$emit('close')"
    @selectOrganization="selectOrganization"
    @pickedDate="pickedDate"
  />
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { SET_PROGRESS_BAR, SET_STATUS_DOWNLOAD } from '@/store/actions/reports'
import DialogFormSaveNomenclatureByProviderAndDate from '@/components/Forms/FormSaveNomenclatureByProviderAndDate/FormSaveNomenclatureByProviderAndDate'

const DocAPI = RepositoryFactory.get('doc')

export default {
  name: 'SaveNomenclature',
  components: {
    DialogFormSaveNomenclatureByProviderAndDate,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOrganization: null,
      date: {
        from: null,
        to: null,
      },
      linkDownloadNomenclature: '',
    }
  },
  computed: {
    statusDownloadNomenclature: {
      get() {
        return this.$store.getters[`reports/getStatusDownload`]
      },
      set(value) {
        this.$store.dispatch(`reports/${SET_STATUS_DOWNLOAD}`, value)
      },
    },
  },
  methods: {
    async createReport() {
      try {
        const response = await DocAPI.createReportForDocuments(
          'document create',
          this.selectedOrganization,
          this.date,
        )
        if (response.data.errors.length) {
          this.$message.error(response.data.errors.join())
          this.statusDownloadNomenclature = 'error'

          return null
        }
        return response.data.model.id
      } catch (e) {
        this.$message.error(e)
      }
    },
    async saveNomenclature(options) {
      const reportId = await this.createReport()
      reportId &&
        (DocAPI.generateReport(
          reportId,
          options.scoupe,
          options.watermark,
          options.combine,
          options.item,
        )
          .then(response => {
            this.$message('Загрузка отчет скоро начнется')
            const reportId = response.data.id
            let timer = setInterval(() => {
              DocAPI.getReportFiles('total-report', reportId).then(res => {
                this.$store.dispatch(
                  `reports/${SET_PROGRESS_BAR}`,
                  res.data.readiness,
                )

                if (res.data.readiness === 100) {
                  this.$message('Загрузка отчета началась')
                  setTimeout(() => {
                    const path = DocAPI.getReportLink(
                      `total-report/${reportId}/download`,
                    )

                    this.downloadRegistry({ path })
                    this.statusDownloadNomenclature = 'ready'
                    clearInterval(timer)
                  }, 1000)
                }
              })
            }, 2000)
          })
          .catch(() => {
            this.$message('Что-то пошло не так')
          }))
    },
    selectOrganization(newVal) {
      this.selectedOrganization = newVal
    },
    pickedDate(newValDateFrom, newValDateTo) {
      this.date.from = newValDateFrom
      this.date.to = newValDateTo
    },
  },
}
</script>
